import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import DateRangePicker from "../../../../DatePickers/DateRangePicker/DateRangePicker";
import EventsAnalysisAPI from "../../../../../api/EventsAnalysisApi";
import Dropdown from "react-dropdown";
import Cookies from "js-cookie";
import ReactLoading from "react-loading";

const freqCalculationOptions = [
    {
        label: "None",
        value: "None",
    },
    {
        label: "ZC Calculation",
        value: "zc_calculation",
    },
    {
        label: "dVdT Calculation",
        value: "snar",
    },
    {
        label: "Power Factor ZC",
        value: "pf_zc",
    },
    {
        label: "Power Factor Raw",
        value: "pf_raw",
    },
    {
        label: "Saturation Reconstruction",
        value: "reconstruction",
    },
    {
        label: "Current Ripple",
        value: "current_ripple",
    },
    {
        label: "Current Insta RMS",
        value: "inst_i_rms",
    },
];

const formatDate = (date) => {
    return date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
};

export default function EventsCapture({ tabData, setTabData, setPlotsOrder }) {
    const token = Cookies.get("Session");

    // extarcting from redux slice
    const { selectedCustomer, selectedFacility, selectedEquipment, equipmentTimezone, showSELMenu } = useSelector(
        (state) => state.equipmentsPortfolio,
    );
    const selectedVoltageType = useSelector((state) => state.voltageType.selectedVoltageType);

    const plotEvent = useSelector((state) => state.plotEvent);

    // Events Capture Tab Hooks
    const [eventCaptureStartDate, setEventCaptureStartDate] = useState(
        new Date(new Date().valueOf() - 1000 * 60 * 60 * 24 * 7),
    );
    const [eventCaptureEndDate, setEventCaptureEndDate] = useState(new Date());

    const [eventFileList, setEventFileList] = useState([]);
    const [selectedFreqCalculationType, setSelectedFreqCalculationType] = useState(freqCalculationOptions[0]);

    const [movingAvgLength, setMovingAvgLength] = useState(1);
    const [isMovingAvgLengthInvalid, setIsMovingAvgLengthInvalid] = useState(false);

    const [eventsCaptureAlert, setEventsCaptureAlert] = useState({
        color: "blue",
        text: "",
        show: false,
    });
    const [isEventsCapturePlotLoading, setIsEventsCapturePlotLoading] = useState(false);

    const [displayEventTimestampLine, setDisplayEventTimestampLine] = useState(false);
    const [displayLLCurrent, setDisplayLLCurrent] = useState(false);

    const [compareFlag, setCompareFlag] = useState(false);
    const [compareType, setCompareType] = useState("time");
    const [fileOne, setFileOne] = useState();
    const [fileTwo, setFileTwo] = useState();

    const [fileOneEquipment, setFileOneEquipment] = useState();
    const [fileTwoEquipment, setFileTwoEquipment] = useState();
    const eventTimeIdx1 = useRef();
    const eventTimeIdx2 = useRef();

    const [fileType, setFileType] = useState("Cloud File");

    useEffect(() => {
        if (showSELMenu == true) {
            setFileType("Cloud File");
        }
    }, [showSELMenu]);

    useEffect(() => {
        const eventFile = eventFileList.find((file) => file.label.includes(plotEvent.time));
        if (eventFile) {
            setTabData((prevState) => {
                return {
                    ...prevState,
                    selectedEventFile: eventFile,
                    showPlotOnDoubleClick: true,
                };
            });
        } else {
            setEventsCaptureAlert({
                color: "primary",
                text: "No Event Found",
                show: true,
            });
        }
    }, [plotEvent]);

    useEffect(() => {
        if (tabData.showPlotOnDoubleClick) {
            onEventCapturePlotButtonClick();
        }
        setTabData((prevState) => {
            return {
                ...prevState,
                showPlotOnDoubleClick: false,
            };
        });
    }, [tabData.showPlotOnDoubleClick]);

    useEffect(() => {
        getEventsList();
    }, [selectedEquipment, equipmentTimezone, fileType]);

    useEffect(() => {
        if (tabData.showPlot && tabData.selectedEventFile) {
            onEventCapturePlotButtonClick();
        }
    }, [selectedVoltageType]);

    useEffect(() => {
        if (selectedEquipment) {
            const equipStartDate = new Date(parseInt(selectedEquipment.equipment_start_epoch * 1000));

            // Reset Date Pickers
            if (equipStartDate > eventCaptureStartDate) {
                const tempDate = new Date(new Date().valueOf() - 1000 * 60 * 60 * 24 * 7);

                if (equipStartDate > tempDate) setEventCaptureStartDate(equipStartDate);
                else setEventCaptureStartDate(tempDate);

                setEventCaptureEndDate(new Date());
            }
        }
    }, [selectedEquipment]);

    useEffect(() => {
        setTabData((prevData) => {
            return {
                ...prevData,
                plotMetaData: {
                    ...prevData.plotMetaData,
                    compareType: compareType,
                },
            };
        });
    }, [compareType]);

    {
        /************************************ Event Capture Tab fuctions **************************************************************/
    }

    const onMovingAvgLengthChange = (newLength) => {
        //Add time delay for set / replot
        const length = parseFloat(newLength);
        setMovingAvgLength(length);
        if (length >= 1 && length <= 1024) {
            setIsMovingAvgLengthInvalid(false);
        } else {
            setIsMovingAvgLengthInvalid(true);
        }
    };

    const getEventsList = (startDate = eventCaptureStartDate, endDate = eventCaptureEndDate) => {
        setEventFileList([]);
        setEventsCaptureAlert({
            color: "primary",
            text: "",
            show: false,
        });
        setTabData((prevData) => {
            return {
                ...prevData,
                eventsTableData: {
                    rows: [],
                    columns: [],
                },
            };
        });
        if (selectedEquipment) {
            const esaPromise = () => {
                if (fileType == "Cloud File") {
                    return EventsAnalysisAPI.get_events_data(
                        token,
                        selectedEquipment.value,
                        formatDate(startDate),
                        formatDate(endDate),
                        equipmentTimezone.value,
                        selectedEquipment.np_current,
                        true,
                        selectedEquipment.product_type,
                        selectedVoltageType.value,
                    );
                } else {
                    return EventsAnalysisAPI.getNodeEventList(
                        token,
                        selectedEquipment.value,
                        formatDate(startDate),
                        formatDate(endDate),
                        equipmentTimezone.value,
                    );
                }
            };

            esaPromise()
                .then((response) => {
                    if (response.status === 204) {
                        setEventsCaptureAlert({
                            color: "primary",
                            text: "No Event Found",
                            show: true,
                        });
                        setTabData((prevData) => {
                            return {
                                ...prevData,
                                eventsTableData: {
                                    rows: [],
                                    columns: [],
                                },
                            };
                        });
                    } else {
                        if (response.data.content == null) {
                            const text = response.data.info;
                            setEventsCaptureAlert({
                                color: "primary",
                                text: text,
                                show: true,
                            });
                        } else {
                            setEventFileList(response.data.content.list_data);
                            setTabData((prevData) => {
                                return {
                                    ...prevData,
                                    eventsTableData: {
                                        rows: response.data.content.table_data.rows,
                                        columns: response.data.content.table_data.columns,
                                    },
                                };
                            });
                        }
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    };

    const onEventCaptureStartDateChange = (date) => {
        setEventCaptureStartDate(date);
        getEventsList(date, eventCaptureEndDate);
    };

    const onEventCaptureEndDateChange = (date) => {
        setEventCaptureEndDate(date);
        getEventsList(eventCaptureStartDate, date);
    };

    const onEventCapturePlotButtonClick = () => {
        if (compareFlag) {
            if (!fileOne || !fileTwo) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select both files",
                });
            } else {
                setTabData((prevData) => {
                    return {
                        ...prevData,
                        plotData: {
                            time: [],
                            current: {
                                Ia: [],
                                Ib: [],
                                Ic: [],
                            },
                            voltage_ln: {
                                Va: [],
                                Vb: [],
                                Vc: [],
                            },
                            analysis: {
                                x_axis_a: [],
                                x_axis_b: [],
                                x_axis_c: [],
                                zc_a: [],
                                zc_b: [],
                                zc_c: [],
                            },
                        },
                        isEventsCapturePlotLoading: true,
                        plotMetaData: {
                            selectedEquipment: selectedEquipment,
                            selectedESA: tabData.selectedEventFile,
                            analysisType: selectedFreqCalculationType.value,
                            selectedVoltageType: selectedVoltageType,
                            displayEventTimestampLine: displayEventTimestampLine,
                            displayLLCurrent: displayLLCurrent,
                            eventTimeIdx: eventTimeIdx1.current,
                            compareFlag: compareFlag,
                            compareType: compareType,
                            fileOne: fileOne,
                            fileTwo: fileTwo,
                            fileOneEquipment: fileOneEquipment,
                            fileTwoEquipment: fileTwoEquipment,
                            eventTimeIdxTwo: eventTimeIdx2.current,
                        },
                        showPlot: true,
                    };
                });
                setIsEventsCapturePlotLoading(true);

                const firstFile = EventsAnalysisAPI.event_capture_plot_data(
                    token,
                    fileOne.value,
                    fileOneEquipment.location_node_id,
                    selectedFreqCalculationType.value,
                    fileOneEquipment.product_type,
                    selectedVoltageType.value,
                    movingAvgLength,
                    displayLLCurrent,
                    fileOne?.label.split(" - ").slice(0, -1).join(""),
                    eventTimeIdx1.current,
                );
                const secondFile = EventsAnalysisAPI.event_capture_plot_data(
                    token,
                    fileTwo.value,
                    fileTwoEquipment.location_node_id,
                    selectedFreqCalculationType.value,
                    fileTwoEquipment.product_type,
                    selectedVoltageType.value,
                    movingAvgLength,
                    displayLLCurrent,
                    fileTwo?.label.split(" - ").slice(0, -1).join(""),
                    eventTimeIdx2.current,
                );
                Promise.all([firstFile, secondFile])
                    .then(([resp1, resp2]) => {
                        if (resp1.status === 200 && resp2.status === 200) {
                            // Remove unused channels for eq_type_sub v1
                            if (fileOneEquipment.eq_type_sub === "v1") {
                                resp1.data.content.plot_data.V2.x = [];
                                resp1.data.content.plot_data.V2.y = [];

                                resp1.data.content.plot_data.V3.x = [];
                                resp1.data.content.plot_data.V3.y = [];
                            }
                            // Remove unused channels for eq_type_sub v1
                            if (fileTwoEquipment.eq_type_sub === "v1") {
                                resp2.data.content.plot_data.V2.x = [];
                                resp2.data.content.plot_data.V2.y = [];

                                resp2.data.content.plot_data.V3.x = [];
                                resp2.data.content.plot_data.V3.y = [];
                            }

                            const data = {
                                plotData1: resp1.data.content.plot_data,
                                plotData2: resp2.data.content.plot_data,
                            };
                            setTabData((prevData) => {
                                return {
                                    ...prevData,
                                    plotData: data,
                                    showPlot: true,
                                    isEventsCapturePlotLoading: false,
                                };
                            });
                            setPlotsOrder({
                                eventsCapture: 1,
                                correlatingEvents: 2,
                                eventsTrending: 3,
                                eventsThreshold: 4,
                                eventsFeaturesPlot: 5,
                                selEventsTrendingPlot: 7,
                            });
                        }
                        setIsEventsCapturePlotLoading(false);
                    })
                    .catch((err) => {
                        setTabData((prevData) => {
                            return {
                                ...prevData,
                                isEventsCapturePlotLoading: false,
                            };
                        });
                        setIsEventsCapturePlotLoading(false);
                        console.log(err);
                    });
            }
        } else {
            if (!selectedCustomer) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select a Customer",
                });
            } else if (!selectedFacility) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select a Facility",
                });
            } else if (!selectedEquipment) {
                setEventsCaptureAlert({
                    color: "primary",
                    show: true,
                    text: "Select an Equipment ",
                });
            } else if (tabData.selectedEventFile === "") {
                setEventsCaptureAlert({
                    color: "primary",
                    text: "Select Event File",
                    show: true,
                });
            } else if (isMovingAvgLengthInvalid) {
                setEventsCaptureAlert({
                    color: "primary",
                    text: "Please select value between 1 and 1024",
                    show: true,
                });
            } else {
                setEventsCaptureAlert({ ...eventsCaptureAlert, show: false });
                setIsEventsCapturePlotLoading(true);

                const eventTimeIdx = tabData.eventsTableData.rows.filter(
                    (row) => row.s3_bucket_key_pair == tabData.selectedEventFile.value,
                )[0]?.zero_sample;

                setTabData((prevData) => {
                    return {
                        ...prevData,
                        plotData: {
                            time: [],
                            current: {
                                Ia: [],
                                Ib: [],
                                Ic: [],
                            },
                            voltage_ln: {
                                Va: [],
                                Vb: [],
                                Vc: [],
                            },
                            analysis: {
                                x_axis_a: [],
                                x_axis_b: [],
                                x_axis_c: [],
                                zc_a: [],
                                zc_b: [],
                                zc_c: [],
                            },
                        },
                        isEventsCapturePlotLoading: true,
                        plotMetaData: {
                            selectedEquipment: selectedEquipment,
                            selectedESA: tabData.selectedEventFile,
                            analysisType: selectedFreqCalculationType.value,
                            selectedVoltageType: selectedVoltageType,
                            displayEventTimestampLine: displayEventTimestampLine,
                            displayLLCurrent: displayLLCurrent,
                            eventTimeIdx: eventTimeIdx,
                            compareFlag: compareFlag,
                            compareType: compareType,
                            fileOne: fileOne,
                            fileTwo: fileTwo,
                            fileOneEquipment: fileOneEquipment,
                            fileTwoEquipment: fileTwoEquipment,
                            eventTimeIdxTwo: null,
                        },
                        showPlot: true,
                    };
                });

                EventsAnalysisAPI.event_capture_plot_data(
                    token,
                    tabData.selectedEventFile.value,
                    selectedEquipment.location_node_id,
                    selectedFreqCalculationType.value,
                    selectedEquipment.product_type,
                    selectedVoltageType.value,
                    movingAvgLength,
                    displayLLCurrent,
                    null,
                    null,
                )
                    .then((response) => {
                        if (response.status === 200) {
                            setTabData((prevData) => {
                                return {
                                    ...prevData,
                                    plotData: response.data.content.plot_data,
                                    showPlot: true,
                                    isEventsCapturePlotLoading: false,
                                };
                            });

                            setPlotsOrder({
                                eventsCapture: 1,
                                correlatingEvents: 2,
                                eventsTrending: 3,
                                eventsThreshold: 4,
                                eventsFeaturesPlot: 5,
                                selEventsTrendingPlot: 7,
                            });
                        }
                        setIsEventsCapturePlotLoading(false);
                    })
                    .catch((err) => {
                        setTabData((prevData) => {
                            return {
                                ...prevData,
                                isEventsCapturePlotLoading: false,
                            };
                        });
                        setIsEventsCapturePlotLoading(false);
                        console.log(err);
                    });
            }
        }
    };

    const handleFileButtonClick = (fileNum, action) => {
        const file = action == "remove" ? null : tabData.selectedEventFile;
        const eq = action == "remove" || !file ? null : selectedEquipment;
        if (action == "add" && !tabData.selectedEventFile) {
            setEventsCaptureAlert({
                color: "primary",
                text: "Select a file",
                show: true,
            });
        }
        if (fileNum == 1) {
            setFileOne(file);
            setFileOneEquipment(eq);
            eventTimeIdx1.current = tabData.eventsTableData.rows.filter(
                (row) => row.s3_bucket_key_pair == file?.value,
            )[0]?.zero_sample;
        } else {
            setFileTwo(file);
            setFileTwoEquipment(eq);
            eventTimeIdx2.current = tabData.eventsTableData.rows.filter(
                (row) => row.s3_bucket_key_pair == file?.value,
            )[0]?.zero_sample;
        }
    };

    return (
        <div>
            <Row>
                <Col>
                    <h2 className="margin-top-10">Events Capture</h2>
                </Col>
            </Row>
            <Row>
                <Col className="event-data col-7">
                    <label>Select Date Range:</label>
                    <br></br>
                    <DateRangePicker
                        startDate={eventCaptureStartDate}
                        endDate={eventCaptureEndDate}
                        onStartDateChange={onEventCaptureStartDateChange}
                        onEndDateChange={onEventCaptureEndDateChange}
                    />
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <label>Select File Location:</label>
                    <Form.Group inline="true">
                        <Form.Check
                            inline="true"
                            checked={fileType == "Cloud File"}
                            onChange={(val) => {
                                setFileType(val.target.value);
                            }}
                            type="radio"
                            label="Cloud"
                            value="Cloud File"
                        />
                        <Form.Check
                            inline="true"
                            type="radio"
                            value="Node File"
                            checked={fileType == "Node File"}
                            label="Node"
                            onChange={(val) => {
                                setFileType(val.target.value);
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <br />
            <Row>
                <Col className="col-7">
                    <label>Select Event File:</label>
                    <br></br>
                    <Dropdown
                        options={eventFileList}
                        value={tabData.selectedEventFile}
                        onChange={(value) => {
                            setTabData((prevState) => {
                                return {
                                    ...prevState,
                                    selectedEventFile: value,
                                };
                            });
                        }}
                    />
                    <br></br>
                </Col>
                <Col className={showSELMenu ? "col-5 d-none" : "col-5"}>
                    <label>Select Analysis Type:</label>
                    <br></br>
                    <Dropdown
                        options={freqCalculationOptions}
                        value={selectedFreqCalculationType}
                        onChange={(val) => setSelectedFreqCalculationType(val)}
                    />
                </Col>
            </Row>
            <br></br>
            <Row>
                <Col>
                    <label>Enter length for moving average:</label>
                    <br></br>
                    <Col className="col-8 margin_left_-15 waveform-sec-ctn">
                        <Form.Control
                            type="number"
                            min={1}
                            max={1024}
                            value={movingAvgLength}
                            onInput={(newDuration) => onMovingAvgLengthChange(newDuration.target.value)}
                            isInvalid={isMovingAvgLengthInvalid}
                            required
                        />
                    </Col>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <Form.Check
                        onChange={(event) => {
                            setDisplayEventTimestampLine(event.target.checked);
                        }}
                        type="checkbox"
                        label="Display Event Timestamp Line"
                        checked={displayEventTimestampLine}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check
                        onChange={(event) => {
                            setDisplayLLCurrent(event.target.checked);
                        }}
                        type="checkbox"
                        label="Display L-L Current"
                        checked={displayLLCurrent}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Check
                        onChange={(event) => {
                            setCompareFlag(event.target.checked);
                        }}
                        type="checkbox"
                        label="Compare Events"
                        checked={compareFlag}
                    />
                </Col>
            </Row>
            {compareFlag && (
                <Row>
                    <Col>
                        <Form.Group inline="true" style={{ paddingLeft: "1rem" }}>
                            <Form.Check
                                inline="true"
                                onChange={(event) => {
                                    setCompareType(event.target.value);
                                }}
                                type="radio"
                                label="Time Align"
                                value="time"
                                checked={compareType == "time"}
                            />
                            <Form.Check
                                inline="true"
                                onChange={(event) => {
                                    setCompareType(event.target.value);
                                }}
                                type="radio"
                                label="Stacked"
                                value="stacked"
                                checked={compareType == "stacked"}
                            />
                        </Form.Group>
                    </Col>
                </Row>
            )}
            {compareFlag ? (
                <>
                    <Row>
                        <Col className="col-6">
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>File 1: {fileOneEquipment ? `SN:${fileOneEquipment.node_sn}` : ""}</Col>
                                        <Col
                                            style={{
                                                textAlign: "right",
                                            }}
                                        >
                                            <button
                                                style={{
                                                    background: "inherit",
                                                    border: "none",
                                                    padding: "0!important",
                                                    color: "#007bff",
                                                    "text-decoration": "underline",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    const action = fileOne ? "remove" : "add";
                                                    handleFileButtonClick(1, action);
                                                }}
                                            >
                                                {fileOne ? "Remove" : "Add File"}
                                            </button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    "background-color": "white",
                                                    border: "1px solid #ccc",
                                                    "border-radius": "2px",
                                                    "box-sizing": "border-box",
                                                    color: "#333",
                                                    cursor: "default",
                                                    outline: "none",
                                                    padding: "8px 52px 8px 10px",
                                                    transition: "all 200ms ease",
                                                }}
                                            >
                                                {fileOne ? fileOne.label : "File 1"}
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col>File 2: {fileTwoEquipment ? `SN:${fileTwoEquipment.node_sn}` : ""}</Col>
                                        <Col
                                            style={{
                                                textAlign: "right",
                                            }}
                                        >
                                            <button
                                                style={{
                                                    background: "inherit",
                                                    border: "none",
                                                    padding: "0!important",
                                                    color: "#007bff",
                                                    "text-decoration": "underline",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    const action = fileTwo ? "remove" : "add";
                                                    handleFileButtonClick(2, action);
                                                }}
                                            >
                                                {fileTwo ? "Remove" : "Add File"}
                                            </button>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    overflow: "hidden",
                                                    "background-color": "white",
                                                    border: "1px solid #ccc",
                                                    "border-radius": "2px",
                                                    "box-sizing": "border-box",
                                                    color: "#333",
                                                    cursor: "default",
                                                    outline: "none",
                                                    padding: "8px 52px 8px 10px",
                                                    transition: "all 200ms ease",
                                                }}
                                            >
                                                {fileTwo ? fileTwo.label : "File 2"}
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <br />
                </>
            ) : (
                <></>
            )}
            <Row>
                <Col className="col-2">
                    {isEventsCapturePlotLoading ? (
                        <ReactLoading type="bars" height={50} width={50} color="#007bff" />
                    ) : (
                        <Button variant="primary" onClick={onEventCapturePlotButtonClick} className="plot_button">
                            Plot
                        </Button>
                    )}
                </Col>
                <Col className="col-5 eventsAlert">
                    <Alert
                        variant={eventsCaptureAlert.color}
                        show={eventsCaptureAlert.show}
                        onClose={() => setEventsCaptureAlert({ ...eventsCaptureAlert, show: false })}
                        dismissible
                    >
                        {eventsCaptureAlert.text}
                    </Alert>
                </Col>
            </Row>
        </div>
    );
}
